(function () {
  function publish(name, payload) {
    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      window.Shopify.analytics.publish(name, payload);
    }
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target || !target.matches) return;

      // Sort dropdown - rendered twice (desktop #SortByContainer, mobile
      // #SortByContainerMobile), both share name="sort_by", and the node is
      // destroyed/recreated on every AJAX facet re-render, so we delegate
      // from document rather than binding to the element directly.
      if (target.matches('select[name="sort_by"]')) {
        publish('collection_sort_used', {
          sortValue: target.value,
          collectionPath: window.location.pathname
        });
        return;
      }

      // Facet checkboxes/radios (color, size, type, vendor, etc.) - Shopify
      // names these filter.p.*, filter.v.*, filter.v.price, etc.
      if (target.matches('input[name^="filter."]') && target.type !== 'number') {
        publish('collection_filter_used', {
          filterName: target.name,
          filterValue: target.value,
          action: target.checked ? 'apply' : 'remove',
          collectionPath: window.location.pathname
        });
        return;
      }

      // Price range number inputs
      if (target.matches('input[name*="price"]')) {
        publish('collection_filter_used', {
          filterName: target.name,
          filterValue: target.value,
          action: 'price_range',
          collectionPath: window.location.pathname
        });
      }
    },
    true
  );
})();
